import anime from 'animejs'
// import axios from 'axios'
import translate from '../translations'

export default {
  name: 'card-edit-orga',

  ui: {
    btEdit: '[js-card-update]',
    btOK: '[js-card-confirm]',
    btDelete: '[js-card-delete]',
    'inputs[]': '[type="text"]',
    'btsPosition[]': '[js-bt-position]',
  },

  events: [
    {
      target: 'btEdit',
      on: 'click',
      handle () {
        this.editCard()
      },
    },
    {
      target: 'btOK',
      on: 'click',
      handle (e) {
        this.validateCard(e)
      },
    },
    {
      target: 'btDelete',
      on: 'click',
      handle (e) {
        this.deleteCard(e)
      },
    },
    {
      target: 'btsPosition',
      on: 'click',
      handle (e) {
        this.positionCard(e)
      },
    },
  ],

  componentDidMount () {
    this.route = this.el.parentNode.parentNode.getAttribute('data-route')
    this.pictUpload = this.el.querySelector('.card--edit-orga__pict-upload')
  },

  editCard () {
    for (let input of this.ui.inputs) {
      input.disabled = false
    }

    this.pictUpload.classList.remove('is-disabled')

    this.ui.btEdit.classList.add('hidden')
    this.ui.btOK.classList.remove('hidden')
  },

  validateCard (e) {
    let allFilled = true
    for (let input of this.ui.inputs) {
      input.classList.remove('is-error')

      if (
        input.value === '' &&
        input.getAttribute('data-name') !== 'function' &&
        input.getAttribute('data-name') !== 'functionEN'
      ) {
        allFilled = false
        input.classList.add('is-error')
      }
    }

    if (allFilled) {
      // const card = e.currentTarget.closest('.card')

      for (let input of this.ui.inputs) {
        input.disabled = true
      }

      this.pictUpload.classList.add('is-disabled')

      this.ui.btOK.classList.add('hidden')
      this.ui.btEdit.classList.remove('hidden')

      /*  if (this.ui.btOK.classList.contains('create')) {
          this.request('create', card)
        } else {
          this.request('update', card)
        } */
    }
  },

  deleteCard (e) {
    // const card = e.currentTarget.closest('.card')
    if (confirm(translate('CONFIRM_DELETE'))) {
      anime({
        targets: this.el,
        height: ['145px', '0px'],
        padding: 0,
        easing: 'easeOutSine',
        duration: 300,
        complete: anim => {
          // this.request('delete', card)
          this.el.parentNode.removeChild(this.el)
        },
      })
    }
    this.ui.btOK.classList.add('hidden')
    this.ui.btEdit.classList.remove('hidden')
  },

  positionCard (e) {
    const target = e.currentTarget
    const dir = target.getAttribute('js-bt-position')
    const card = target.closest('.card')
    const list = card.closest('.cards-list')
    const nodes = Array.from(list.children)
    let index = nodes.indexOf(card)

    if (dir === 'up' && index > 0) {
      list.insertBefore(card, nodes[index - 1])
    } else if (dir === 'down' && index < nodes.length) {
      list.insertBefore(card, nodes[index + 2])
    }

    // this.request('sort', null)
    list.querySelectorAll('.card').forEach((el, i) => {
      el.querySelectorAll('input[type=hidden]')[1].value = i
    })
  },

  /*
  request (pAction, card) {
    let formData = new FormData()
    formData.append('action', pAction)

    if (pAction === 'sort') {
      let data = ''
      for (let card of this.el.parentNode.querySelectorAll('.card')) {
        if (card.getAttribute('data-id') !== 'xxx') {
          data += `${card.getAttribute('data-id')},`
        }
      }
      data = data.slice(0, -1)
      formData.append('ids', data)
    } else if (
      pAction === 'update' ||
      pAction === 'delete' ||
      pAction === 'create'
    ) {
      formData.append('id', card.getAttribute('data-id'))
      formData.append(
        'firstname',
        card.querySelector('input[name="firstname"]').value
      )
      formData.append(
        'lastname',
        card.querySelector('input[name="lastname"]').value
      )
      formData.append(
        'function',
        card.querySelector('input[name="function"]').value
      )
      formData.append(
        'functionEN',
        card.querySelector('input[name="functionEN"]').value
      )
    }

    axios
    // .post(`${this.route}/?action=${pAction}&ids=${data}`)
      .post(this.route, formData)
      .then(response => {
        // console.log(response.data)
        if (pAction === 'create') {
          card.setAttribute('data-id', response.data.id)
          this.ui.btOK.classList.remove('create')

          // this is dirty, fix me please https://suivi.bigyouth.fr/projects/134?modal=Task-20823-134
          window.location.reload(false)
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error)
      })
  }, */
}
